import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'

const StyledDeleteButton = styled.button`
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: ${rem(32)};
  height: ${rem(32)};
  color: var(--gameday-buttons-iconColor, ${theme.buttons.iconColor});
  cursor: pointer;

  ${props =>
    props.isInline &&
    css`
      flex-direction: row-reverse;
    `}

  &:focus {
    outline: 0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
`

const StyledIcon = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
  fill: currentColor;
`

function DeleteButton({ label, disabled, onClick }) {
  return (
    <StyledDeleteButton onClick={onClick} disabled={disabled}>
      <StyledIcon viewBox="0 0 32 32">
        <path d="M14.233 13.587a.644.644 0 0 0-.458.19.655.655 0 0 0-.19.462v5.891c0 .173.07.34.19.462a.644.644 0 0 0 .458.19.694.694 0 0 0 .444-.203c.12-.12.191-.28.203-.449v-5.89a.705.705 0 0 0-.203-.45.694.694 0 0 0-.444-.203ZM17.768 13.587a.694.694 0 0 0-.445.204.705.705 0 0 0-.202.448v5.891a.695.695 0 0 0 .647.652.644.644 0 0 0 .457-.19.655.655 0 0 0 .19-.462v-5.89a.655.655 0 0 0-.19-.462.644.644 0 0 0-.457-.191Z" />
        <path d="M23.351 10.37h-3.73v-.63c0-.462-.181-.904-.505-1.23a1.718 1.718 0 0 0-1.22-.51h-3.794c-.457 0-.896.183-1.22.51a1.747 1.747 0 0 0-.505 1.23v.63h-3.73a.644.644 0 0 0-.457.19.655.655 0 0 0-.19.462.635.635 0 0 0 .366.596.621.621 0 0 0 .238.056H9.79l.69 10.696c.02.444.211.864.534 1.168.322.305.75.47 1.19.462h7.59c.441.008.869-.157 1.19-.462.323-.304.515-.724.535-1.168l.69-10.696h1.142a.62.62 0 0 0 .591-.37.636.636 0 0 0 .056-.239v-.043a.655.655 0 0 0-.19-.461.644.644 0 0 0-.457-.191Zm-9.68-.63a.436.436 0 0 1 .431-.436h3.795a.436.436 0 0 1 .431.435v.63H13.67v-.63Zm6.554 12.543a.415.415 0 0 1-.41.413h-7.61a.404.404 0 0 1-.393-.235.412.412 0 0 1-.038-.157v-.021l-.669-10.61h9.788l-.668 10.61Z" />
      </StyledIcon>
      <span className="sr-only">{label}</span>
    </StyledDeleteButton>
  )
}

DeleteButton.defaultProps = {
  label: 'Delete',
  onClick: () => {},
}

export default DeleteButton
